import React, { useEffect, useState } from 'react'
import { stakeHoldersData } from './StakeHoldersData'
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Card, Grid } from '@material-ui/core';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1
    },
    gridContainerOuter: {
        margin: '6px -6px',
        display: 'flex',
        justifyContent: 'center'
    },
    gridItemInner: {
        padding: '0px 6px'
    },
    listTitle: {
        padding: 15
    },
    listItem: {
        padding: 16
    },
    titleDiv: {
        padding: '8px 0px 12px 0px'
    },
});

function StakeHolderView({ match }) {
    const classes = useStyles();
    const [stake, setStake] = useState({})
    useEffect(() => {
        console.log(match)
        let id = match.params.id
        let obj = stakeHoldersData.filter(item => item.id === id)
        setStake(obj)
    }, [match])
    return (

        <div className={classes.root}>

            <div className={classes.titleDiv}>
                <Typography variant="h2">Stake Holder - View</Typography>
            </div>

            <Grid container className={classes.gridContainerOuter}>
                <Grid item xs={12} className={classes.gridItemInner}>

                    <Card >

                        <div>
                            <Typography variant="h4" className={classes.listTitle}>Holder Details</Typography>
                            {
                                (stake && stake.length) ?
                                    (

                                        <List component="nav" className={classes.root} >
                                            <ListItem divider className={classes.listItem}>
                                                <Typography variant="h6">ID :{stake[0].id}</Typography>
                                            </ListItem>
                                            <ListItem divider className={classes.listItem}>
                                                <Typography variant="h6">Holder Name: {stake[0].holderName}</Typography>
                                            </ListItem>
                                            <ListItem divider className={classes.listItem}>
                                                <Typography variant="h6">Email: {stake[0].email}</Typography>
                                            </ListItem>
                                            <ListItem divider className={classes.listItem}>
                                                <Typography variant="h6">Number Of Shares: {stake[0].numberOfShares}</Typography>
                                            </ListItem>
                                            <ListItem divider className={classes.listItem}>
                                                <Typography variant="h6">Value Of Investment: {stake[0].valueOfInvestment}</Typography>
                                            </ListItem>
                                        </List>

                                    ) : (
                                        <div className={classes.listTitle}>
                                            <Typography variant="h5">Stake Holder information not found</Typography>
                                        </div>
                                    )
                            }

                        </div>

                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default StakeHolderView
